import ImagesController from './images.controller.js';
import imagesTpl from './images.html';

export default function imagesRouter($stateProvider) {
  $stateProvider.state('app.images', {
    url: '/images',
    templateUrl: imagesTpl,
    controller: ImagesController,
    controllerAs: 'vm',
    data: {
      authorizedPermissions: ['IMG_MGMT_READ'],
    },
  });
}



// WEBPACK FOOTER //
// ./src/app/images/images.router.js